import {EventEmitter, Injectable, Output} from '@angular/core';
import {Observable, Observer, Subject} from 'rxjs';
import {ConfService} from './conf.service';
import {environment} from "../environments/environment";
import {MessagingService} from './services/messaging.service';
import { StompState } from '@stomp/ng2-stompjs';
import {filter} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class WebsocketService {
    public msg = [];
    public notifcationCount: number;
    private messagingService: MessagingService;
    messageHistory = [];
    state = 'NOT CONNECTED';
    previouslyConnected = false;

    @Output() createAPIEventEmitter = new EventEmitter<any>();


    constructor(private confPost: ConfService) {
        // this.initializeWebSocketConnection();
    }


    initializeKingerConnection(query) {
        this.disconnect();
        return new Promise((resolve, reject) => {
            const WEBSOCKET_URL = 'wss://' + environment.kingerHostName + '/apiplatform-ws?' + query;

            this.messagingService = new MessagingService(WEBSOCKET_URL);

            const MAX_RETRIES = 3;
            let numRetries = MAX_RETRIES;

            const retrySub = this.messagingService.state().pipe(
                filter((state: number) => state === StompState.CLOSED)
            ).subscribe(() => {
                if (numRetries <= 0 && !this.previouslyConnected) {
                    this.messagingService.disconnect();
                    retrySub.unsubscribe();
                }
                numRetries--;
            });

            this.messagingService.connectObservable().subscribe(() => {
                numRetries = MAX_RETRIES;
            });

            this.messagingService.state().subscribe((state: StompState) => {
                this.state = StompState[state];
                if (this.state === 'CONNECTED') {
                    this.previouslyConnected = true;
                }
            });

            resolve('success');

        });
    }

    initializeWebSocketConnection(ralam, emailId, user_environment, password, shash) {
        this.disconnect();
        return new Promise((resolve, reject) => {
            const WEBSOCKET_URL = 'wss://' + environment.kingerHostName + '/apiplatform-ws?ralam=' + ralam + '&emailId=' + emailId + '&environment=' + user_environment + '&password=' + password + '&shash=' + shash;

            this.messagingService = new MessagingService(WEBSOCKET_URL);

            const MAX_RETRIES = 3;
            let numRetries = MAX_RETRIES;

            const retrySub = this.messagingService.state().pipe(
                filter((state: number) => state === StompState.CLOSED)
            ).subscribe(() => {
                if (numRetries <= 0 && !this.previouslyConnected) {
                    this.messagingService.disconnect();
                    retrySub.unsubscribe();
                }
                numRetries--;
            });

            this.messagingService.connectObservable().subscribe(() => {
                numRetries = MAX_RETRIES;
            });

            this.messagingService.state().subscribe((state: StompState) => {
                this.state = StompState[state];
                if (this.state === 'CONNECTED') {
                    this.previouslyConnected = true;
                }
            });

            resolve('success');

        });
    }

    disconnect() {
        if (this.messagingService) {
            if (this.messagingService.isOpen()) {
                this.messagingService.disconnect();
            }
        }
    }

    isOpen() {
        if (this.messagingService) {
            return this.messagingService.isOpen();
        } else {
            return false;
        }
    }

    checkConnection() {
        return new Promise((resolve, reject) => {
            if (this.messagingService) {
                resolve(this.isOpen());
            } else {
                resolve(false);
            }
        });
    }

    listenAPICreation(partner, account, apiName, version, session, timestamp , action): Observable<any> {
        // const observable = new Observable(observer => {
        //     this.stompClient.subscribe('/topic/' + partner + '.' + account + '.' + apiName + '.' + version + '.' + session + '.' + timestamp.toString() + '.' + action + '.response', (message) => {
        //         if (message.body) {
        //             const temp = JSON.parse(message.body);
        //             observer.next(temp);
        //         }
        //     });
        // });

        const queueName = partner + '.' + account + '.' + apiName + '.' + version + '.' + session + '.' + timestamp.toString() + '.' + action;
        if (this.isOpen()) {
            return this.messagingService.subscribe('/topic/' + queueName + '.response', queueName);
        } else {
            return new Observable();
        }
    }

    listenToTopic(queueName): Observable<any> {
        if (this.isOpen()) {
            return this.messagingService.subscribe('/topic/' + queueName + '.response', queueName);
        } else {
            return new Observable();
        }
    }


    addNotificationsListener(topic): Observable<any> {
        if (this.isOpen()) {
            return this.messagingService.addNotificationsTopic(topic);
        } else {
            return new Observable();
        }
    }

    unsubscribeTopic() {
        this.messagingService.unsubscribe();
    }

    listenNotificationCount(): Observable<any> {
        const observable = new Observable(observer => {
            observer.next(this.notifcationCount);
            return () => {
            };
        });
        return observable;
    }

    sendApiMessage(data, partner, account, timeStamp, sessionID) {

        const queueName = data.partner + '.' + data.account + '.' + data.apiName + '.' + data.apiVersion + '.' + sessionID + '.' + data.timeStamp.toString() + '.' + data.action;

        if (this.isOpen()) {
            this.messagingService.send('/app/' + queueName + '.message', data);
        } else {
            this.confPost.postPubSubMessage(data.partner, data.account, localStorage.getItem('partnerKey'), queueName, data).subscribe(
                response => {}, error => {});
        }
    }
}
